/**
 * WEB COPY of LetterRecorderScreen.tsx — picked by the web bundler ahead of
 * the mobile file; Metro never sees it.
 *
 * There is no browser recorder yet (see LetterRecordOfferScreen.web.tsx for
 * why), so the recorder route shows the same "record on your phone" screen.
 * A direct URL to /LetterFirst/LetterRecorder never renders the phone
 * recorder, whose record button cannot work here.
 */
import { LetterRecordOfferScreen } from './LetterRecordOfferScreen.web';

export const LetterRecorderScreen = LetterRecordOfferScreen;

export default LetterRecorderScreen;
